import { useMutation } from '@tanstack/react-query'
import { hisApi } from '../api/hisApi'
import { patientApi } from '../api/patientApi'
import { PatientSearchResult } from '../types/patient'

export const useSearchPatient = () => {
  return useMutation<PatientSearchResult, Error, string>({
    mutationFn: async (keyword: string): Promise<PatientSearchResult> => {
      const value = keyword.trim()

      const isCardId = /^\d{13}$/.test(value)
      const isHN = /^\d+$/.test(value) && !isCardId

      if (isHN) {
        const db = await patientApi.getPatients({
          hn: value,
        })

        if (db.length > 0) {
          return {
            source: 'db',
            data: db,
          }
        }

        const his = await hisApi.getPatientByHn(value)

        if (his) {
          return {
            source: 'his',
            data: his,
          }
        }

        return {
          source: 'db',
          data: [],
        }
      }

      const params: {
        cardId?: string
        name?: string
      } = {}

      if (isCardId) {
        params.cardId = value
      } else {
        params.name = value
      }

      const db = await patientApi.getPatients(params)

      return {
        source: 'db',
        data: db,
      }
    },
  })
}
